import { sva } from "@stubhub/broadway-foundation/css";

export const cwyloCarouselRecipe = sva({
  slots: [
    "root",
    "header",
    "dateBadge",
    "dateBadgeDay",
    "dateBadgeDayOfMonth",
    "dateBadgeMonth",
    "dateBadgeYear",
    "headerText",
    "title",
    "subtitle",
    "note",
    "seeAll",
    "card",
    "image",
    "cardBody",
    "cardTitle",
  ],
  className: "cwyloCarousel",
  base: {
    root: {
      width: "full",
    },
    header: {
      display: "flex",
      alignItems: "center",
      columnGap: "primitives.150",
      paddingInline: "primitives.200",
      paddingBlockEnd: "primitives.200",
    },
    dateBadge: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      minWidth: "primitives.600",
      paddingBlock: "primitives.75",
      paddingInline: "primitives.100",
      borderStartStartRadius: "primitives.100",
      borderStartEndRadius: "primitives.100",
      borderEndEndRadius: "primitives.100",
      borderEndStartRadius: "primitives.100",
      backgroundColor: "bg.surface",
      boxShadow: "raised",
    },
    dateBadgeDay: {
      color: "text.subtle",
      textTransform: "uppercase",
    },
    dateBadgeDayOfMonth: {
      color: "text",
      fontWeight: "bold",
    },
    dateBadgeMonth: {
      color: "text.subtle",
      textTransform: "uppercase",
    },
    dateBadgeYear: {
      color: "text.subtle",
    },
    headerText: {
      display: "flex",
      flexDirection: "column",
      rowGap: "primitives.25",
      flexGrow: "1",
      flexShrink: "1",
      flexBasis: "primitives.0",
      minWidth: "primitives.0",
    },
    title: {
      color: "text",
      overflowX: "hidden",
      overflowY: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    seeAll: {
      flexShrink: "0",
      color: "text",
    },
    card: {
      display: "flex",
      flexDirection: "column",
      width: "full",
      textDecorationLine: "none",
      color: "text",
    },
    image: {
      width: "full",
      aspectRatio: "[4/3]",
      objectFit: "cover",
      borderStartStartRadius: "primitives.200",
      borderStartEndRadius: "primitives.200",
      borderEndEndRadius: "primitives.200",
      borderEndStartRadius: "primitives.200",
      backgroundColor: "bg.surface",
    },
    cardBody: {
      display: "flex",
      flexDirection: "column",
      rowGap: "primitives.25",
      paddingBlockStart: "primitives.100",
    },
    cardTitle: {
      overflowX: "hidden",
      overflowY: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
});
